﻿import { Component} from '@angular/core';
import { Tabla } from 'src/app/_components/tabla';


@Component({ templateUrl: 'lista.component.html' })
export class RootListaComponent {

    data: any;

    tabla: Tabla = {
        titulo: 'Listas',
        hideHeader: false,
        hideFilter: false,
        externalData: false,
        endPoint: '/rest-api/root/lista',
        editable: true,
        nuevo: false,
        routeLink: '/user/lista', 
        columnas: [
            {
                name: 'id',
                prop: 'id',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 75,
                hidden: true
            },
            {
                name: 'Nombre',
                prop: 'nombre',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 100
            },
            {
                name: 'C&oacute;digo',
                prop: 'codigo',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 100
            },
            {
                name: 'Usuario ID',
                prop: 'createdBy',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 100
            },
            {
                name: 'Creaci&oacute;n',
                prop: 'createdDate',
                editable: false,
                resizeable: true,
                sortable: true,
                datePipe: true,
                width: 100
            },
            {
                name: 'F. Evento',
                prop: 'fecha',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 100
            },
            {
                name: 'Vigente',
                prop: 'vigente',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 100
            },
            {
                name: 'Activa',
                prop: 'activa',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 100
            },
            {
                name: 'Mail',
                prop: 'mail',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 100
            }
        ]
    };

    constructor() {}

}
